export enum RegistryActionsEnum {
  Uploaded = 'uploaded',
  SentToPayment = 'sent_to_payment',
  Deleted = 'deleted',
}
